module.exports = __webpack_public_path__ + "img/bacha_yes.a2d0a07e.png";